import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConstants } from '../constant/app.constants';

@Injectable()
export class OptionService {
    constructor(private http: HttpClient) {
    }

    getSelectOption(id) {
        return this.http.post<any>(AppConstants.SITE_URL +'option/get_select_options', { id: id });
    }

}




// WEBPACK FOOTER //
// /var/www/delios/delios-live/app/src/app/services/option.service.ts